import axios from '../plugins/axios';

/**
 * Aggregate reports from admin endpoints.
 * Room & course endpoints match legacy Reports.vue usage.
 */
export async function fetchRoomBookingsReport(params = {}) {
  const res = await axios.get('/admin/reports/room-bookings', {
    params: {
      report_type: params.report_type || 'monthly',
      room_id: params.room_id ?? undefined
    }
  });
  return res.data?.data ?? res.data ?? [];
}

export async function fetchCourseReservationsReport(reportType = 'monthly') {
  const res = await axios.get('/admin/reports/course-reservations', {
    params: { report_type: reportType }
  });
  if (res.data?.success && Array.isArray(res.data.data)) {
    return res.data.data;
  }
  return Array.isArray(res.data?.data) ? res.data.data : [];
}

/** Optional backend aggregated space report — same shape idea as rooms */
export async function fetchSpaceBookingsReport(params = {}) {
  try {
    const res = await axios.get('/admin/reports/space-bookings', {
      params: {
        report_type: params.report_type || 'monthly',
        study_space_id: params.study_space_id ?? params.space_id ?? undefined
      }
    });
    const data = res.data?.data ?? res.data;
    return Array.isArray(data) ? data : [];
  } catch (_) {
    return null;
  }
}
